<template>
  <section class="w3l-contact-1 w3hny-form-btm py-5" id="contact">
    <div class="contacts-9 py-lg-5 py-md-4">
      <div class="container">
        <div class="header-sec text-center mb-5">
          <br/>
          <h1 class="title-w3l">
            Blog
          </h1>
        </div>
        <div class="contactct-fm map-content-9">
          <br/>
          <div class="clearfix"></div>
          <p>Learn more about lead generation and marketing strategies here.</p><br/>
          <br/>
        </div>
        <br/>
        <div class="row">
          <div class="col-md-4">
            <NuxtLink to="/blog/social-media-marketing">
              <div class="card blue-background">
                <img src="/assets/images/social-3408791_1280.webp" class="card-img-top" alt="Social media marketing">
                <div class="card-body">
                  <h5 class="card-title white-text">Social Media Marketing</h5>
                  <p class="card-text white-text ellipsis">Social media marketing (SMM) is the use of social media platforms to interact with customers to build brands, increase sales, and drive website traffic.</p>
                </div>
              </div>
            </NuxtLink>
            <br/>
          </div>
          <div class="col-md-4">
            <NuxtLink to="/blog/forum-marketing">
              <div class="card blue-background">
                <img src="/assets/images/social-media-5187243_1280.webp" class="card-img-top" alt="Forum marketing">
                <div class="card-body">
                  <h5 class="card-title white-text">Forum Marketing</h5>
                  <p class="card-text white-text ellipsis">Forum marketing involves sharing valuable insights, answering questions, or providing advice, all while subtly directing forum participants towards a specific brand or offering.</p>
                </div>
              </div>
            </NuxtLink>
            <br/>
          </div>
          <div class="col-md-4">
            <NuxtLink to="/blog/sales-leads">
              <div class="card blue-background">
                <img src="/assets/images/lead-magnet-7791403_1280.webp" class="card-img-top" alt="Sales leads">
                <div class="card-body">
                  <h5 class="card-title white-text">Sales Leads</h5>
                  <p class="card-text white-text ellipsis">Sales leads are potential sales contacts, individuals or organizations that express  interest in your goods or services.</p>
                </div>
              </div>
            </NuxtLink>
            <br/>
          </div>
          <div class="col-md-4">
            <NuxtLink to="/blog/how-to-improve-saas-customer-retention-with-data-driven-strategies">
              <div class="card blue-background">
                <img src="/assets/images/shopping-8042865_1280.webp" class="card-img-top" alt="A man holding shopping bags">
                <div class="card-body">
                  <h5 class="card-title white-text">Keeping Customers</h5>
                  <p class="card-text white-text ellipsis">How to Improve SaaS Customer Retention with Data-Driven Strategies</p>
                </div>
              </div>
            </NuxtLink>
            <br/>
          </div>
          <div class="col-md-4">
            <NuxtLink to="/blog/the-ultimate-guide-to-lead-generation-in-2024">
              <div class="card blue-background">
                <img src="/assets/images/lead magnet istock photo.webp" class="card-img-top" alt="A magnet attracting people">
                <div class="card-body">
                  <h5 class="card-title white-text">Getting Customers</h5>
                  <p class="card-text white-text ellipsis">The Ultimate Guide to Lead Generation in 2024</p>
                </div>
              </div>
            </NuxtLink>
            <br/>
          </div>
          <div class="col-md-4">
            <NuxtLink to="/blog/how-to-qualify-leads-effectively-a-step-by-step-approach">
              <div class="card blue-background">
                <img src="/assets/images/unqualified.webp" class="card-img-top" alt="A person cutting a paper with 'Unqualified' written on it with a pair of scissors">
                <div class="card-body">
                  <h5 class="card-title white-text">Qualifying Leads</h5>
                  <p class="card-text white-text ellipsis">How to Qualify Leads Effectively: A Step-by-Step Approach</p>
                </div>
              </div>
            </NuxtLink>
            <br/>
          </div>
          <div class="col-md-4">
            <NuxtLink to="/blog/how-to-develop-a-content-marketing-strategy-a-beginners-guide">
              <div class="card blue-background">
                <img src="/assets/images/how-to-develop-content-marketing-strategy.webp" class="card-img-top" alt="A laptop with 'content marketing' written on it's screen">
                <div class="card-body">
                  <h5 class="card-title white-text">Content Strategy</h5>
                  <p class="card-text white-text ellipsis">How to Develop a Content Marketing Strategy: A Beginner’s Guide</p>
                </div>
              </div>
            </NuxtLink>
            <br/>
          </div>
          <div class="col-md-4">
            <NuxtLink to="/blog/twitter-tips-2025">
              <div class="card blue-background">
                <img src="/assets/images/twitter-seo-tips-2025.webp" class="card-img-top" alt="Twitter and X icon on a phone">
                <div class="card-body">
                  <h5 class="card-title white-text">Twitter SEO Tips</h5>
                  <p class="card-text white-text ellipsis">Discover 10 essential tips for increasing your visibility on Twitter in 2025</p>
                </div>
              </div>
            </NuxtLink>
            <br/>
          </div>
          <div class="col-md-4">
            <NuxtLink to="/blog/10-tips-to-build-a-strong-digital-presence-in-2025">
              <div class="card blue-background">
                <img src="/assets/images/digital-presence.webp" class="card-img-top" alt="A modern and visually appealing cover image for a blog post titled 10 Tips to Build a Strong Digital Presence in 2025 The design should feature elements representing digital marketing such as social media">
                <div class="card-body">
                  <h5 class="card-title white-text">Digital Presence</h5>
                  <p class="card-text white-text ellipsis">10 Tips to Build a Strong Digital Presence in 2025</p>
                </div>
              </div>
            </NuxtLink>
            <br/>
          </div>
          <div class="col-md-4">
            <NuxtLink to="/blog/how-to-respond-to-online-reviews-the-10-golden-rules">
              <div class="card blue-background">
                <img src="/assets/images/online_reviews.jpeg" class="card-img-top" alt="A Person Typing on Laptop">
                <div class="card-body">
                  <h5 class="card-title white-text">Online Reviews</h5>
                  <p class="card-text white-text ellipsis">How to Respond to Online Reviews. The 10 Golden Rules</p>
                </div>
              </div>
            </NuxtLink>
            <br/>
          </div>
          <div class="col-md-4">
            <NuxtLink to="/blog/25-effective-ways-to-drive-traffic-to-your-website-free-and-paid-methods">
              <div class="card blue-background">
                <img src="/assets/images/1.jpeg" class="card-img-top" alt="Turned on Imac Beside Macbook on Table">
                <div class="card-body">
                  <h5 class="card-title white-text">Drive Traffic</h5>
                  <p class="card-text white-text ellipsis">25 Effective Ways to Drive Traffic to Your Website (Free and Paid Methods)</p>
                </div>
              </div>
            </NuxtLink>
            <br/>
          </div>
<!--          <div class="col-md-4">-->
<!--            <NuxtLink to="/blog/understanding-psychographics-in-marketing-a-comprehensive-exploration">-->
<!--              <div class="card blue-background">-->
<!--                <img src="/assets/images/5.jpg" class="card-img-top" alt="A Marketing analysis with psychographics in the notepad">-->
<!--                <div class="card-body">-->
<!--                  <h5 class="card-title white-text">Understanding Psychographics</h5>-->
<!--                  <p class="card-text white-text ellipsis">Understanding Psychographics in Marketing: A Comprehensive Exploration</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </NuxtLink>-->
<!--            <br/>-->
<!--          </div>-->
                    <div class="col-md-4">
                      <NuxtLink to="/blog/how-social-media-is-reshaping-the-retail-landscape">
                        <div class="card blue-background">
                          <img src="/assets/images/2.jpeg" class="card-img-top" alt="Person Holding Iphone Showing Social Networks Folder">
                          <div class="card-body">
                            <h5 class="card-title white-text">Social Media</h5>
                            <p class="card-text white-text ellipsis">How Social Media is Reshaping the Retail Landscape</p>
                          </div>
                        </div>
                      </NuxtLink>
                      <br/>
                    </div>

          <div class="col-md-4">
            <NuxtLink to="/blog/11-closing-phrases-that-consistently-seal-the-deal-use-these-today">
              <div class="card blue-background">
                <img src="/assets/images/3.jpg" class="card-img-top" alt="Salesperson shaking hands after closing deal">
                <div class="card-body">
                  <h5 class="card-title white-text">Social Media</h5>
                  <p class="card-text white-text ellipsis">11 Closing Phrases That Consistently Seal the Deal (Use These Today)</p>
                </div>
              </div>
            </NuxtLink>
            <br/>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">

useHead({
  //@ts-ignore
  title: `ForumLeadsFinder – Read out blog posts`,
  meta: [
    {
      name: "description",
      //@ts-ignore
      content: `ForumLeadsFinder - Get the latest marketing developments in our blog posts`
    }
  ]
});

</script>


<style scoped>
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.blue-background:hover {
  background: blue;
}

.blue-background:hover .white-text {
  color: white;
}

.card-img-top{
  height: 250px;
  object-fit: cover;
}
</style>
